interface IEventContent<C> {
    content: C;
}

export type GlobalEventDistributor = {
    registerStore: Function;
    listenEvent: Function;
    removeEvent: Function;
    dispatchEvent: Function;
};

export const globalEventDistributor = (): GlobalEventDistributor => {
    let stores: Array<unknown> = [];
    const registerStore = (store: unknown): void => {
        stores.push(store);
    };

    const listenEvent = (eventType: string, callback: (event: Event) => void): void => {
        window.addEventListener(eventType, event => {
            event.preventDefault();
            if (callback) {
                callback(event);
            }
        });
    };

    const removeEvent = (eventType: string, callback: () => void): void => {
        window.removeEventListener(
            eventType,
            event => {
                event.preventDefault();
                if (callback) {
                    callback();
                }
            },
            false
        );
    };

    const dispatchEvent = <T>(event: string, data?: T) => {
        const detail: IEventContent<T | undefined> = {
            content: data,
        };
        const customEvt = new CustomEvent<IEventContent<T | undefined>>(event, {
            detail,
        });
        window.dispatchEvent(customEvt);
    };

    return {
        registerStore,
        listenEvent,
        removeEvent,
        dispatchEvent,
    };
};
